// Propósito: helpers puros para filtrar entidades del header.
export function normalizeTerm(event: any): string {
  return String(event ?? '').toLowerCase().trim();
}

// Filtra la lista por término, devuelve la base si está vacío.
export function filterByTerm(list: any[], term: string): any[] {
  if (!term) return list;
  return applyTerm(list, term);
}

// Aplica el término sobre la lista completa.
export function applyTerm(list: any[], term: string): any[] {
  return list.filter((item) => matchesEntity(item, term));
}

// Indica si la entidad coincide con el término.
export function matchesEntity(entity: any, term: string): boolean {
  return entityHaystack(entity).includes(term);
}

// Construye el texto buscable de la entidad en minúsculas.
export function entityHaystack(entity: any): string {
  return entityParts(entity).join(' ').toLowerCase();
}

// Extrae los campos buscables de la entidad.
export function entityParts(entity: any): any[] {
  return [entity.code, entity.name, entity.group?.name, entity.office?.name, entity.office?.acronym];
}
